import { default as chatBot } from './bot/store' 
import { default as systemAlertMessage } from './alert/store'

export default { 
	chatBot,
	systemAlertMessage
}
